export default __webpack_public_path__ + "static/media/98t.8d05a4cd.jpg";